import React from "react";

import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";

import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";

export default class extends React.Component {
  render() {
    return (
      <TableContainer>
        <Table stickyHeader size="small" aria-label="">
          <Header {...this.props} />
          <Body {...this.props} />
          <Footer {...this.props} />
        </Table>
      </TableContainer>
    );
  }
}
